// Third party packages
import { throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { ApiService } from "src/app/shared/services/api.service";
import { HelperService } from "src/app/shared/services/helper.service";
import * as i0 from "@angular/core";
import * as i1 from "../../shared/services/api.service";
import * as i2 from "../../shared/services/helper.service";
var UsersService = /** @class */ (function () {
    /**
     * Class constructor
     */
    function UsersService(apiService, helperService) {
        this.apiService = apiService;
        this.helperService = helperService;
    }
    /**
     * Create a new user
     *
     * @since 1.0.0
     *
     * @param user User data
     * @returns Observable<any>
     */
    UsersService.prototype.create = function (user) {
        return this.apiService.apiCall("POST", "users", user, undefined, undefined, undefined, "v2");
    };
    /**
     * Get users list for given query params
     *
     * @since 1.0.0
     *
     * @param [start] Query left offset
     * @param [limit] Results number
     * @param [sort] Sorting field name
     * @param [sortVersus] Sorting versus. Can be 'asc' or 'desc'
     * @param [search] Filtering object with fildering data string
     */
    UsersService.prototype.getList = function (start, limit, sort, sortVersus, search) {
        var params = { start: start, limit: limit, sort: sort, sortVersus: sortVersus };
        if (search) {
            Object.keys(search).forEach(function (key) {
                var newParamKey = "search[" + key + "]";
                var newParamValue = search[key];
                params[newParamKey] = newParamValue;
            });
        }
        return this.apiService.apiCall("GET", "users", params, undefined, undefined, undefined, "v2");
    };
    /**
     * Get users list for given query params
     *
     * @since 1.0.0
     *
     * @param [start] Query left offset
     * @param [limit] Results number
     * @param [sort] Sorting field name
     * @param [sortVersus] Sorting versus. Can be 'asc' or 'desc'
     * @param [search] Filtering object with fildering data string
     */
    UsersService.prototype.getTaggerList = function (start, limit, sort, sortVersus, search) {
        var params = { start: start, limit: limit, sort: sort, sortVersus: sortVersus };
        if (search) {
            Object.keys(search).forEach(function (key) {
                var newParamKey = "search[" + key + "]";
                var newParamValue = search[key];
                params[newParamKey] = newParamValue;
            });
        }
        return this.apiService.apiCall("GET", "users/tagger", params, undefined, undefined, undefined, "v2");
    };
    /**
     * Get an exportation file of all users
     * role: role of user that has sent the request, admin, operator etc.
     * companyId: company Id of the user that has sent the request. Only for Master and Collaborator
     * usersToExport: users to export, "all" | "temporary". Only for Master and Collaborator
     *
     * @since 1.0.0
     */
    UsersService.prototype.getExport = function (role, companyId, usersToExport) {
        var _this = this;
        return this.apiService
            .apiCall("GET", "users/export", { role: role, companyId: companyId, usersToExport: usersToExport }, { responseType: "blob" }, undefined, undefined, "v2")
            .pipe(catchError(function (err) {
            return _this.helperService.parseErrorBlob(err);
        }));
    };
    /**
     * Get given userId data from back-end
     *
     * @since 1.0.0
     *
     * @param userId ID of the user to get
     */
    UsersService.prototype.get = function (userId) {
        var _this = this;
        return this.apiService
            .apiCall("GET", "users/" + userId, undefined, undefined, undefined, undefined, "v2")
            .pipe(catchError(function (err) {
            _this.helperService.handleError(err);
            return throwError(err);
        }));
    };
    /**
     * Update user with given userId with given user data
     *
     * @since 1.0.0
     *
     * @param userId ID of user to update
     * @param data New user's data
     */
    UsersService.prototype.update = function (userId, data) {
        return this.apiService.apiCall("PUT", "users/" + userId, data, undefined, undefined, undefined, "v2");
    };
    /**
     * Update user fields with given userId with given user data
     *
     * @since 1.0.0
     *
     * @param userId ID of user to update
     * @param data New user's data
     */
    UsersService.prototype.updateFields = function (userId, data) {
        return this.apiService.apiCall("PATCH", "users/" + userId, data, undefined, undefined, undefined, "v2");
    };
    /**
     * Update user role private policy
     *
     * @since 1.0.0
     *
     * @param userId ID of user to update
     * @param data New user's data
     */
    UsersService.prototype.updatePrivacy = function (userId, roleId, data) {
        return this.apiService.apiCall("PATCH", "users/privacy/" + userId + "/" + roleId, data, undefined, undefined, undefined, "v2");
    };
    /**
     * Delete permanently an user
     *
     * @since 1.0.0
     *
     * @param userId ID of the user
     */
    UsersService.prototype.delete = function (userId, companyId) {
        if (typeof companyId !== "undefined" && companyId !== "") {
            // Remove user from company only
            return this.apiService.apiCall("DELETE", "users/" + userId + "/" + companyId, undefined, undefined, undefined, undefined, "v2");
        }
        return this.apiService.apiCall("DELETE", "users/" + userId, undefined, undefined, undefined, undefined, "v2");
    };
    /**
     * Send to user an email with an OTP tha he must use
     * within 3 minutes to reset his email
     *
     * @since 1.0.0
     *
     * @param email email of user
     */
    UsersService.prototype.recoverPassword = function (email) {
        var _this = this;
        return this.apiService
            .apiCall("POST", "users/recover-password", { email: email })
            .pipe(catchError(function (err) {
            _this.helperService.handleError(err);
            return throwError(err);
        }));
    };
    /**
     * Reset the password of a user.
     * Verified with a token that he must use within X seconds
     * (see settings)
     *
     * @since 1.0.0
     */
    UsersService.prototype.resetPassword = function (password, email, token) {
        return this.apiService.apiCall("POST", "auth/reset-password/" + token, {
            password: password,
            email: email,
        }, undefined, undefined, undefined, "v2");
    };
    UsersService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function UsersService_Factory() { return new UsersService(i0.ɵɵinject(i1.ApiService), i0.ɵɵinject(i2.HelperService)); }, token: UsersService, providedIn: "root" });
    return UsersService;
}());
export { UsersService };
